import { safeT } from '@/shared/localization';
import type { Translator } from '@/shared/localization';
import { ResolvedErrorAction } from './resolve-error-action';

const NEGATIVE_TOAST_STATUS = 'negative' as const;

export interface ErrorHandlerDeps {
  toast?: (opts: { text: string; status: 'negative' }) => void;
  redirect?: (path: string) => void;
  refetch?: () => void;
  t?: Translator<'error'>;
}

function getErrorMessage(
  i18nKey: string | undefined,
  t: Translator<'error'> | undefined,
): string | undefined {
  if (!t) {
    return undefined;
  }

  if (i18nKey) {
    // code.${i18nKey} 는 런타임 조립 동적 키라 메시지 키 유니온으로 좁혀지지 않는다.
    // safeT 로 키 존재 시 번역, 없으면 원문(i18nKey)을 노출한다.
    return safeT(t, `code.${i18nKey}`, i18nKey);
  }

  return t('code.fallback');
}

export function executeErrorAction(
  resolved: ResolvedErrorAction,
  deps: ErrorHandlerDeps,
): void {
  switch (resolved.action.type) {
    case 'toast': {
      const message = getErrorMessage(resolved.i18nKey, deps.t);
      if (message) {
        deps.toast?.({ text: message, status: NEGATIVE_TOAST_STATUS });
      }
      return;
    }
    case 'redirect':
      deps.redirect?.(resolved.action.to);
      return;
    case 'refetch':
      deps.refetch?.();
      return;
    case 'stay':
    case 'boundary':
      return;
  }
}
